import { ArrowUpRight } from "lucide-react";
import { INSIGHTS, WA_MESSAGES, waLink } from "./data";
import { ArrowCta, Eyebrow, MaskLines, Reveal } from "./ui-bits";

const Insights = () => (
  <section
    id="insights"
    className="border-t border-obsidian/10 bg-ivory text-obsidian"
    data-testid="insights-section"
  >
    <div className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-36">
      <Eyebrow tone="dark">06 / Insights</Eyebrow>
      <h2 className="mt-6 font-serif text-4xl leading-[1.02] sm:text-5xl lg:text-6xl">
        <MaskLines lines={["THE MARKET,", "ELEVATED."]} />
      </h2>

      <div className="mt-16">
        {INSIGHTS.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.07}>
            <a
              href={waLink(WA_MESSAGES.insights)}
              target="_blank"
              rel="noreferrer"
              className="group flex items-center gap-6 border-t border-obsidian/15 py-7 transition-colors duration-500 last:border-b hover:bg-obsidian/[0.03] md:gap-10"
              data-testid={`insight-row-${i + 1}`}
            >
              <div className="hidden h-20 w-32 shrink-0 overflow-hidden sm:block" data-cursor="view">
                <img
                  src={a.img}
                  alt=""
                  className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                />
              </div>
              <div className="flex-1">
                <div className="text-[10px] font-medium uppercase tracking-[0.26em] text-champagne">
                  {a.cat}
                </div>
                <h3 className="mt-2 font-serif text-xl leading-snug transition-transform duration-500 group-hover:translate-x-2 md:text-2xl">
                  {a.title}
                </h3>
              </div>
              <ArrowUpRight
                size={20}
                className="shrink-0 text-obsidian/40 transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-obsidian"
              />
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-12">
          <ArrowCta dark href={waLink(WA_MESSAGES.insights)} testId="insights-view-all">
            View All Insights
          </ArrowCta>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Insights;
